module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "eurus-banner-background eurus-image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/jolly_ryans.jpg"),
      "height": "129",
      "alt": "Jolly Ryans"
    }
  }), _vm._v(" "), _c('h3', [_c('span', {
    staticClass: "eurus-motto"
  }, [_vm._v("Integrity, Dependability, Trust")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30e19474","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 39
// module chunks = 11